const state = {active: 0}

const mutations = {
  SET (state, active) {
    state.active = active
  }
}

const actions = {
  set: function ({commit}, m) {
    let active = (m === '1' || m === 1) ? 1 : 0
    commit('SET', active)
  }
}

const getters = {
  get: function (state) {
    return state.active
  }
}

export const FilterMapActive = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/filters/FilterMapActive.js